<template>
  <div class="ipdn_detail_inner ipdn_history pool_detail" ref="inner">
    <header>
      <h1>
        <!-- {{$t('Label.I/P, D/N File')}} -->
        I/P, D/N
      </h1>
      <el-dropdown v-if="attachmentFiles && attachmentFiles.length" class="drawer" trigger="click" placement="bottom" @command="onDropDownClick" :tabindex="-1">
        <tw-button class="menu_button" type="secondary" size="small" icon="menu">Menu</tw-button>
        <el-dropdown-menu class="permit_drawer nowrap">
          <el-dropdown-item command="upload">Attach File</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </header>

    <tw-button v-if="res" type="secondary" size="small" class="toggle_button" :class="{ open: expand }" @click="openToggle">
      <img src="@/assets/images/icons/view_all.svg">
    </tw-button>

    <table class="card">
      <template v-if="res && Object.keys(res).length">
        <tw-process-list
          :isPermitHistory="true"
          v-for="table in filteredSchemas"
          :table="table" :key="table.name"
          :initSelectIp="ipPreviewItems.length > 0"
          :initSelectDn="dnPreviewItems.length > 0"
          :initialOpen="true"
          :subtaskHide="true"
        />
      </template>
    </table>

    <div v-if="res && Object.keys(res).length" class="card _linking">
      <div class="item">
        <div class="title">Trading/FlowID</div>
        <div class="value">{{getTradingFlowId()}}</div>
      </div>
      <div class="item">
        <div class="title">Trading Name</div>
        <div class="value">{{tradeManagement.tradingManageName}}</div>
      </div>
      <div class="item">
        <div class="title">Flow Name</div>
        <div class="value">{{tradeManagement.tradingFlowName}}</div>
      </div>
      <!-- TODO: Ph3で非表示に 次Ph以降で対応 -->
      <!-- <div class="item">
        <div class="title">Invoice No</div>
        <div class="value">{{invoiceNo}}</div>
      </div> -->
      <div class="item process">
        <div class="title">Process</div>
        <div class="value link" @click="link">{{getProcessName()}}</div>
      </div>
      <div class="item">
        <div class="title">From - To</div>
        <div class="value flex">
          <div class="company">
            <figure class="avatar">
              <img :src="tradeManagement.from.fromCompanyIcon" v-default-src="'user'">
            </figure>
            <el-tooltip placement="bottom" popper-class="mcu header_tooltip" :tabindex="-1">
              <div slot="content">
                <div class="company_name">{{tradeManagement.from.fromCompanyName}}<br />{{tradeManagement.from.fromSectionName}}</div>
              </div>
              <p class="name">{{tradeManagement.from.fromCompanyShortName}}</p>
            </el-tooltip>
          </div>
          <div class="while">-</div>
          <div class="company">
            <figure class="avatar">
              <img :src="tradeManagement.to.toCompanyIcon" v-default-src="'user'">
            </figure>
            <el-tooltip placement="bottom" popper-class="mcu header_tooltip" :tabindex="-1">
              <div slot="content">
                <div class="company_name">{{tradeManagement.to.toCompanyName}}<br />{{tradeManagement.to.toSectionName}}</div>
              </div>
              <p class="name">{{tradeManagement.to.toCompanyShortName}}</p>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <!-- 添付済のファイルエリア -->
    <div v-show="res" class="attachment" ref="attachment">
      <div class="attach">
        <div>Attach File</div>
      </div>
      <div v-for="(doc, index) in attachmentFiles" :key="`attach_${index}`" class="attach_links">
        <div class="file">
          <div class="inner">
            <div class="user">
              <figure class="avatar table"><img :src="doc.updateUserIcon"></figure>
              <el-tooltip placement="top" popper-class="mcu" :tabindex="-1">
                <div slot="content">{{doc.updateUserName}}</div>
                <div class="from_name">{{doc.updateUserName}}</div>
              </el-tooltip>
            </div>
            <el-tooltip placement="top-start" popper-class="mcu" :tabindex="-1">
              <div slot="content">{{doc.documentName}}</div>
              <span>
                <a v-if="checkLinking(doc.documentManageId)" class="file_name download" @click.prevent="download(doc)" tabindex="-1">{{doc.documentName}}</a>
                <a v-else class="file_name" tabindex="-1">{{doc.documentName}}</a>
              </span>
            </el-tooltip>
            <span class="meta">{{doc.documentSize | fileSize}},&nbsp;{{doc.updateDate | dateTimeFormat}}</span>
          </div>
        </div>
      </div>
    </div>

    <tw-to-top v-if="mounted" :container="$refs.inner" class="detail-to-top" />
  </div>
</template>

<script>
import _ from 'lodash';
import { $api } from '@/store/ApiClient';
import TwProcessList from '@/components/organisms/TwProcessList';
import TwToTop from '@/components/atoms/TwToTop';
import TwButton from '@/components/atoms/TwButton';
// import { COMPANY_ROLE_CD, PROCESS_TYPE, PROCESS_ID, DELETE_FLG, IP_DN_LINK_FLG } from 'lib-tw-common';
import { processNames } from '@/dictionaries/map.js';

import schemas from '@/dictionaries/processes/miip.json';
import { DELETE_FLG , IP_REGIST_TYPE } from 'lib-tw-common';

// import { createIpDnData } from '@/utils/createIpDnData';

// スタブ
// import ipExample from '@/../public/ipExample.json';
// import dnExample from '@/../public/dnExample.json';

export default {
  name: 'TwIpDnArchiveDetailInner',
  components: {
    TwProcessList,
    TwToTop,
    TwButton
  },
  provide() {
    return {
      s: this,
      activeTab: null
    };
  },
  props: {
    item: Object,
    tradeManagement: Object,
    documents: Array
  },
  data() {
    return {
      res: null,
      expand: true,
      mounted: false
    };
  },
  computed: {
    // スキーマを表示するテーブルのみにフィルタ NOTE: 輸出(輸入)通関個別、商品個別 remarksGrpは除く
    filteredSchemas() {
      let tables = _.cloneDeep(schemas.tables);
      tables = _.reject(tables, table => {
        if (table.variableName === 'linkageMarineInsurance' && this.item.docType === 'IP') {
          return false;
        } else if (table.variableName === 'marineInsuranceSeparate' && this.item.docType === 'DN') {
          return false;
        } else return true;
      });
      const exclude = this.item.docType === 'DN' ? ['keyGrp', 'remarksGrp'] : ['keyGrp', 'insuranceTermsGrp', 'insurancePolicyGrp', 'forwarderIpGrp', 'remarksGrp'];
      _.forEach(tables, table => {
        table.groups = _.filter(table.groups, group => {
          return !exclude.includes(group.variableName);
        });
      });
      // console.log(this.item.docType, tables)
      return tables;
    },
    // I/P情報表示用のデータを生成します（プロセス詳細）
    ipPreviewItems() {
      if (!_.get(this.res, 'linkageMarineInsurance.ippools')) {
        return [];
      }
      let ret = _.map(this.res.linkageMarineInsurance.ippools, pool => {
        return {
          docType: 'I/P',
          senderCompanyId: pool.policyGrp.senderCompanyId,
          ipRegistType: pool.ipRegistType,
          ipDnType: pool.policyGrp.ipDnType,
          ipDnTypeDn: _.get(pool, 'policyGrp.ipDnTypeDn'),
          shipperReferenceNo: pool.policyGrp.shipperReferenceNo,
          opOcProvNo: pool.policyGrp.opOcProvNo,
          insurancePolicyNo: pool.policyGrp.insurancePolicyNo,
          insurancePolicyBranchNo: pool.policyGrp.insurancePolicyBranchNo,
          invoiceNo: pool.invoiceGrp.invoiceNo,
          assuredsEtc: pool.assuredGrp.assuredsEtc
        };
      });
      // ipDnTypeDnがある、かつ、1以上のデータはDNから追加したIP情報のため除外
      ret = _.reject(ret, pool => {
        return pool.ipDnTypeDn;
      });
      return ret;
    },
    // D/N情報表示用のデータを生成します（プロセス詳細）
    dnPreviewItems() {
      if (!_.get(this.res, 'marineInsuranceSeparate.dnpools')) {
        return [];
      }
      const ret = _.map(this.res.marineInsuranceSeparate.dnpools, dn => {
        const targetIp = _.find(this.res.linkageMarineInsurance.ippools, ip => {
          // DNから追加したIP情報を検索
          const ipPolicy = ip.policyGrp;
          const dnPolicy = dn.policyGrp;
          // DNから追加したIPかどうか + IPとDNのキー情報が一致しているかどうか
          return (
            ip.ipRegistType === IP_REGIST_TYPE.DN &&
            ipPolicy.ipDnTypeDn === dnPolicy.ipDnType &&
            ipPolicy.senderCompanyId === dnPolicy.senderCompanyId &&
            ipPolicy.insurancePolicyNo === dnPolicy.insurancePolicyNo &&
            ipPolicy.insurancePolicyBranchNo === dnPolicy.insurancePolicyBranchNo &&
            ipPolicy.trx === dnPolicy.trx
          );
        });
        return {
          docType: 'D/N',
          senderCompanyId: dn.policyGrp.senderCompanyId,
          ipDnType: targetIp ? targetIp.policyGrp.ipDnType : '',
          ipDnTypeDn: dn.policyGrp.ipDnType,
          insurancePolicyNo: dn.policyGrp.insurancePolicyNo,
          insurancePolicyBranchNo: dn.policyGrp.insurancePolicyBranchNo,
          shipperReferenceNo: targetIp ? targetIp.policyGrp.shipperReferenceNo : '',
          opOcProvNo: targetIp ? targetIp.policyGrp.opOcProvNo : '',
          invoiceNo: targetIp ? targetIp.invoiceGrp.invoiceNo : '',
          assuredsEtc: targetIp ? targetIp.assuredGrp.assuredsEtc : ''
        };
      });
      return ret;
    },
    attachmentFiles() {
      const target = _.find(_.get(this, 'res.ipDnLatest', []), ipdn => {
        return ipdn.docType === this.item.docType && ipdn.senderCompanyId === this.item.senderCompanyId && ipdn.insurancePolicyNo === this.item.insurancePolicyNo && ipdn.insurancePolicyBranchNo === this.item.insurancePolicyBranchNo && ipdn.ipDnType === this.item.ipDnType && ipdn.trx === this.item.trx;
      });
      return target ? target.attachmentFiles : [];
    }
  },
  created() {
    this.fetch();
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    cloneDeep(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    async fetch() {
      // スタブ
      // this.res = {}
      // const ip = createIpDnData(dnExample, 'IP', _.get(dnExample, 'ipDnTypeDn'));
      // const dn = createIpDnData(dnExample, 'DN');
      // this.$set(this.res, 'linkageMarineInsurance', {
      //   ippools: [ip],
      // });
      // if (this.item.docType === 'DN') {
      //   this.$set(this.res, 'marineInsuranceSeparate', {
      //     dnpools: [dn],
      //   });
      //   this.res.marineInsuranceSeparate.dnpools = this.getIpDnPools(this.res.marineInsuranceSeparate.dnpools);
      // } else {
      //   this.res.linkageMarineInsurance.ippools = this.getIpDnPools(this.res.linkageMarineInsurance.ippools);
      // }
      // return

      // アーカイブ詳細取得
      // bff_ip_4 I/P保管プロセス詳細初期表示BFF
      const params = {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'get_/v1/store-ip/{entityId}/{processId}/{processSeq}/initial',
          path: {
            entityId: this.tradeManagement.entityId,
            processId: this.tradeManagement.processId,
            processSeq: parseInt(this.tradeManagement.processSeq)
          },
          query: {
            processTrx: this.item.processTrx
          }
        }
      };

      $api
        .request(params)
        .then(res => {
          if (this.item.docType === 'DN') {
            res.marineInsuranceSeparate.dnpools = this.getIpDnPools(res.marineInsuranceSeparate.dnpools);
          } else {
            res.linkageMarineInsurance.ippools = this.getIpDnPools(res.linkageMarineInsurance.ippools);
            // this.invoiceNo = _.get(res, 'linkageMarineInsurance.ippools[0].invoiceGrp.invoiceNo', '');
          }
          this.res = res;
        })
        .catch(err => {
          this.$store.dispatch('SHOW_ALERT', err.message);
        });
    },
    openToggle() {
      this.expand = !this.expand;
      if (this.expand) this.$emit('openAll');
      else this.$emit('closeAll');
    },
    // プロセス詳細へ遷移
    link() {
      // プロセス詳細小窓から開いていた場合は、ドロワーを閉じる
      this.$emit('close');
      return;
    },
    getTradingFlowId() {
      const tradingId = this.tradeManagement.tradingId;
      const flowId = this.tradeManagement.tradingFlowId;
      return `${tradingId ? tradingId + '/' : ''}${flowId || ''}`;
    },
    getProcessName() {
      return _.get(processNames[this.tradeManagement.processId.replace(/\d/g, '')], 'nameEn', '');
    },
    // アーカイブ詳細のプールから選択中のIP,DN情報のみにフィルタリング
    getIpDnPools(pools) {
      if (!pools) return [];
      return _.filter(pools, pool => {
        const policy = pool.policyGrp;
        // キー項目が一致しない場合は除外
        return (
          policy.ipDnType === this.item.ipDnType &&
          policy.senderCompanyId === this.item.senderCompanyId &&
          policy.insurancePolicyNo === this.item.insurancePolicyNo &&
          policy.insurancePolicyBranchNo === this.item.insurancePolicyBranchNo &&
          policy.trx === this.item.trx
        );
      });
    },
    // 添付ファイルダウンロード
    download(doc) {
      const path = {
        documentManageId: _.get(doc, 'documentManageId'),
        documentTrx: _.get(doc, 'documentTrx')
      };
      const documentName = _.get(doc, 'documentName');
      $api
        .download(path, documentName)
        .then(() => {})
        .catch(err => {
          this.$store.dispatch('SHOW_ALERT', err.message);
        });
    },
    // ドロップダウンメニュー
    onDropDownClick(command) {
      if (command === 'upload') {
        const scrollHeight = this.$refs.inner.scrollHeight;
        const clientHeight = this.$refs.inner.clientHeight;
        this.$refs.inner.scrollTo({ top: scrollHeight - clientHeight, behavior: 'smooth' });
      }
    },
    // プロセスに紐づいているかどうか
    checkLinking(documentManageId) {
      const target = _.find(this.res.documents, file => {
        return file.documentManageId === documentManageId;
      });
      return target && target.deleteFlg === DELETE_FLG.NOT_DELETED;
    }
  }
};
</script>

<style lang="scss" scoped>
.ipdn_detail_inner {
  padding: 30px 35px;
  position: relative;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .delete {
      margin: -30px 32px 0 auto;
    }

    &.deleted {
      flex-wrap: wrap;
      .drawer.el-dropdown {
        // width: 100%;
        .el-dropdown-link.ellipsis {
          margin: 0 16px 0 auto;
        }
      }
    }
  }
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .column {
      height: 41px;
      display: flex;
      align-items: center;
      margin-bottom: 22px;
      &:last-child {
        justify-content: flex-end;
      }
    }
    .tw_entity_icon {
      margin-right: 8px;
    }
    .title {
      font-weight: bold;
      font-size: 24px;
      line-height: 35px;
      margin-right: 8px;
    }
    .tw_status_icon {
      margin-right: 24px;
    }
    .tw_button {
      margin-right: 24px;
    }
  }
  table.card {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    box-shadow: 0;
    overflow: hidden;
    margin-bottom: 20px;
    // box-shadow: 0px 4.11278px 8.22556px rgba(170, 170, 204, 0.5);
    &.excustom {
      margin-bottom: 32px;
      ::v-deep .tw_process_list > .inner {
        display: none;
      }
    }
  }
  .card._linking {
    margin: 40px 0 24px;
    padding: 24px;
    box-shadow: none;
    border: 1px solid $color_gray_300;
    border-radius: 6px;
    .item {
      display: flex;
      font-size: 14px;
      margin-bottom: 24px;
      &:hover {
        background: white;
        .value {
          color: $color_black;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      .title {
        width: 40%;
        color: $color_gray_800;
      }
      .value.flex {
        display: flex;
        align-items: center;
        .while {
          margin: 0 16px;
        }
      }
      .company {
        display: flex;
        align-items: center;
        figure.avatar {
          width: 32px;
          height: 32px;
          margin-right: 8px;
        }
        .name {
          max-width: 58px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      &.process {
        .value {
          color: $color_dark_blue;
          &.link {
            cursor: pointer;
          }
        }
      }
    }
  }

  &.ipdn_history {
    height: 100vh;
    overflow-y: scroll;
  }
}

.attach_links {
  font-size: 14px;
  line-height: 20px;
  .file {
    position: relative;
    margin-top: 8px;
    padding-left: 16px;
    padding-right: 48px;
    border-radius: 6px;
    padding-top: 12px;
    padding-bottom: 12px;
    background: $color_gray_100;

    &:first-child {
      margin-top: 12px;
    }

    .inner {
      display: flex;
      align-items: center;
      width: 100%;
    }

    .user {
      max-width: 200px;
      margin-right: 12px;
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 20px;
      color: $color_black;
      .from_name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    a.file_name {
      display: block;
      max-width: 400px;
      margin-right: 10px;
      cursor: pointer;
      text-decoration: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.download {
        color: $color_dark_blue;
      }
    }
  }
}
.attach {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
.attachment {
  position: relative;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 40px;
}
.buttons {
  display: flex;
  justify-content: right;
  padding: 24px;
}
</style>
<style lang="scss">
.el-dropdown-menu.el-popper.permit_drawer {
  z-index: 3000 !important;
}
</style>
